<template>
  <div>
    <h3 class="title mb-0">{{ hospital.title }}</h3>
    <router-link
      v-if="canEdit && hospitalId"
      :title="$t('router.editingHospital')"
      :to="{ name: 'hospital-edit', params: { id: hospitalId } }"
      type="button"
      class="btn btn-link icon icon-edit icon_primary"
    >
    </router-link>
    <button
      v-if="showBackToHospitals"
      class="btn btn-with-icon btn-text-only text-small"
      type="button"
      @click="backToHospitalsList"
    >
      <span class="icon icon-arrow icon_secondary"></span>{{ $t('src/components/hospitalheader.1254') }}
    </button>
  </div>
</template>

<script>
import http from '@/modules/http.js'
import { userRights } from '@/mixins/user-rights'

export default {
  name: 'HospitalHeader',
  mixins: [userRights],
  data: () => ({
    hospital: {
      title: ''
    }
  }),
  computed: {
    hospitalId() {
      if (this.isNeuroAdmin) {
        return this.$store.getters.SELECTED_HOSPITAL
      }
      if (this.$store.getters.AUTH_USER) {
        return this.$store.getters.AUTH_USER.hospital_id
      }
      return null
    },
    showBackToHospitals() {
      return this.isNeuroAdmin && this.$store.getters.IS_SELECTED_HOSPITAL
    },
    canEdit() {
      return this.isAnyAdmin
    }
  },
  mounted() {
    this.getHospital()
  },
  watch: {
    hospitalId() {
      this.getHospital()
    }
  },
  methods: {
    getHospital() {
      if (!this.hospitalId) {
        return
      }
      http
        .get('/hospitals/' + this.hospitalId)
        .then(response => {
          this.hospital = response.data
        })
        .catch(error => console.log(error))
    },
    backToHospitalsList() {
      this.$router.push('/hospitals')
    }
  }
}
</script>
